import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"



export const requestChat = async ({ chatId, userClass, verbose=false}) => {
    const formData = new FormData()
    formData.append("chat_id", chatId)
    formData.append("user_class", userClass)
    return secureAPICall({endpoint: BACKEND_URI+"/api/fetch-chat", body: formData, verbose:verbose})
}

export const requestChats = async ({ userId, verbose = false }) => {
    return secureAPICall({endpoint: BACKEND_URI+"/api/fetch-active-chats", verbose: verbose})
}

export const requestFetchTaggedChats = async ({ entriesPerPage, currentPage, tagged, verbose = false }) => {
    const formData = new FormData()
    formData.append("entries_per_page", entriesPerPage)
    formData.append("current_page", currentPage)
    formData.append("tagged", tagged)
    formData.append("default", true)
    return secureAPICall({endpoint: BACKEND_URI+"/api/fetch-tagged-chats", body: formData, verbose: verbose})
}

export const requestChatIds = async ({ verbose = false }) => {
    return secureAPICall({endpoint: BACKEND_URI+ "/api/fetch-active-chat-ids", verbose: verbose})
}


export const requestAddTicketToChat = async ({ ticketId, verbose = false }) => {
    const formData = new FormData();
    formData.append('ticket_id', ticketId)
    return secureAPICall({endpoint: BACKEND_URI+ "/api/add-ticket-to-chat", body: formData, verbose: verbose})
}


export const requestAddTicketsToChat = async ({ ticketIds, verbose = false }) => {
    const formData = new FormData();
    ticketIds.forEach(element => {
        formData.append('ticket_ids', element)
    });
    return secureAPICall({ endpoint: BACKEND_URI + "/api/add-tickets-to-chat", body: formData, verbose: verbose })
}


export const requestRemoveTicketFromChat = async ({ ticketId, verbose = false }) => {
    const formData = new FormData();
    formData.append('ticket_id', ticketId)
    return secureAPICall({endpoint: BACKEND_URI+"/api/remove-ticket-from-chat", body: formData, verbose: verbose})
}


export const requestRemoveTicketsFromChat = async ({ ticketIds, verbose = false }) => {
    const formData = new FormData();
    ticketIds.forEach(element => {
        formData.append('ticket_ids', element)
    });
    return secureAPICall({endpoint: BACKEND_URI + "/api/remove-tickets-from-chat", body: formData, verbose: verbose})
}


export const requestNewChatMessage = async ({chatId, user_class, message, sender_id, sender_name, ticket_id, attachments, replyTo, verbose=false}) => {
    const formData = new FormData()
    formData.append("chatId", chatId)
    formData.append("user_class", user_class)
    formData.append("message", message)
    formData.append("sender_id", sender_id)
    formData.append("sender_name", sender_name)
    formData.append("ticket_id", ticket_id)
    formData.append("reply_to", JSON.stringify(replyTo))

    attachments.forEach(element => {
        formData.append('attachments', element)
    });
    if (attachments.length === 0) {
        formData.append('attachments', [])
    }
    return secureAPICall({ endpoint: BACKEND_URI + "/api/new-chat-message", body: formData, verbose: verbose})
}


export const requestPinTicket = async({pinned, ticketId, verbose = false}) => {
    const formData = new FormData()
    formData.append("pinned", pinned)
    formData.append("id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/pin-ticket", body: formData, verbose: verbose })
}


export const requestIsPinnedTicket = async({ ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/is-pinned-ticket", body: formData, verbose: verbose })
}